import {
  API_END_POINT,
  axiosInstance,
  ENTITY_MANAGER_END_POINTS,
} from '@app-store'

export const fetchMacrosApi = async (
  entityName: string,
  recordId: number,
  macros: string[]
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}${ENTITY_MANAGER_END_POINTS.ENTITY_DATA}/${entityName}`,
    {
      recordId: recordId,
      macros: macros,
    }
  )
}
